import { render, staticRenderFns } from "./VoteStatusBar.vue?vue&type=template&id=c778b74c&scoped=true&"
import script from "./VoteStatusBar.vue?vue&type=script&lang=js&"
export * from "./VoteStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./VoteStatusBar.vue?vue&type=style&index=0&id=c778b74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c778b74c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
